/* eslint-disable import/extensions */

import { webBorrowerPortalService } from "./mfe-remotes-config/remoteConfig.js";

window[webBorrowerPortalService.urlGlobalVariable] =
  webBorrowerPortalService.url;

import("./bootstrap.jsx");
